export enum ReportStatus {
    New = 'New',
    Resolved = 'Resolved'
}

export enum ReportSource {
    Room = 'Room',
    Story = 'Story',
    PM = 'PM',
    Admin = 'Admin'
}

export enum UserType {
    User = 'user',
    Operator = 'operator',
    Unauthorized = 'unauthorized',
}

export enum ReportReason {
    Spam = 'spam',
    NoOneInChat = 'noOneInChat',
    NoOneInVideo = 'noOneInVideo',
    MoreOneInVideo = 'moreOneInVideo',
    Scam = 'scam',
    HateSpeechLegacy = 'hateSpeechLegacy',
    Violence = 'violence',
    Animals = 'animals',
    HateSpeech = 'hateSpeech',
    Nudity = 'nudity',
    Harassment = 'harassment',
    Illegal = 'illegal',
    InappropriateContent = 'inappropriateContent',
    Underage = 'underage',
    MoreOneInChat = 'moreOneInChat',
    Other = 'other',
    InappropriateBehavior = 'inappropriateBehavior',
    DuplicateAccount = 'duplicateAccount',
    AutoDetectNudity = 'autoDetectNudity'
}
